/* eslint-disable */
import {querySelectorAll, getClosestElement, appendElement, removeElement} from "app/lib/helperjs";

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }
  if (typeof Array.prototype.forEach != 'function') {
    Array.prototype.forEach = function (callback) {
        for (var i = 0; i < this.length; i++) {
            callback.apply(this, [this[i], i, this]);
        }
     };
    }

    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
     }


const TARGET_CLASS = '._popup';
const TARGET_NAME = 'data-target';
const POPUP_ATTR = '[data-popup]';
const BREAKPOINT_SMALL = 599;

export class Popup {
    static init() {
        const self = new Popup();

        if (!self.targets.length || !self.popups.length) {
            return;
        }

        const popups = self._preparePopups();
        self._attachClickEvents(popups);
    }

    get targets() {
        return querySelectorAll(TARGET_CLASS);
    }

    get popups() {
        return querySelectorAll(POPUP_ATTR);
    }

    /** @private */
    _preparePopups() {
        const popups = [];

        this.targets.forEach((target) => {
            const name = target.getAttribute(TARGET_NAME);
            const popup = getClosestElement(target, `[data-popup="${name}"]`);

            if (!name || !popup) {
                return;
            }

            removeElement(popup);
            appendElement(popup);

            popups.push({
                target,
                popup
            });
        });

        return popups;
    }

    /** @private */
    _attachClickEvents(popups) {
        popups.forEach((item) => {
            const {target, popup} = item;

            target.addEventListener('click', () => this._togglePopup(target, popup));
            window.addEventListener('click', (event) => {
                const actualTarget = event.target.hasAttribute('data-target') ? event.target : event.target.closest('[data-target]');
                actualTarget !== target && popup.classList.remove('visible');
            });
        })
    }

    /** @private */
    _togglePopup(target, popup) {
        this._setPopupSize(popup);
        this._setPopupPosition(target, popup);

        if (popup.classList.contains('visible')) {
            popup.style.top = '-9999px';
        }

        popup.classList.toggle('visible');
    }

    /** @private */
    _setPopupSize(popup) {
        const documentWidth = window.document.body.getBoundingClientRect().width;

        if (documentWidth < BREAKPOINT_SMALL) {
            popup.style.maxWidth = `${documentWidth - 50}px`;
        }
    }

    /** @private */
    _setPopupPosition(target, popup) {
        const documentDimensions = window.document.body.getBoundingClientRect();
        const targetPosition = target.getBoundingClientRect();
        const positionTop = targetPosition.top + window.scrollY - popup.offsetHeight - 10;
        let positionLeft = targetPosition.left + (targetPosition.width / 2) - (popup.offsetWidth / 2);

        if (positionLeft < 0) {
            positionLeft = targetPosition.left + (targetPosition.width / 2) - 20;
            popup.classList.add('left');
        }

        if (positionLeft + popup.offsetWidth > documentDimensions.width) {
            positionLeft = 25;
            popup.classList.add('no-arrow');
        }

        popup.style.left = `${positionLeft}px`;
        popup.style.top = `${positionTop}px`;
    }
}
